@if (movementOrderDetails) {
  <sc-flex vertical fitHeight stretchContent>
    <sc-dialog-title>
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.movement-orders.moving-order-rerouting-dialog.titl"></sc-dictionary-label>
    </sc-dialog-title>
    <div class="hint">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.movement-orders.moving-order-rerouting-dialog.description"></sc-dictionary-label>
    </div>
    <sc-flex-fitting-content vertical>
      <app-structure-selection [request]="structureSelectionRequest" (selectionChanged)="handleSelectionChange($event)"></app-structure-selection>
    </sc-flex-fitting-content>
    <sc-padding>
      <sc-flex>
        <sc-content-spacer grow></sc-content-spacer>
        <sc-button (click)="cancelDialog()" dictionaryKey="tmc-yard.common.action.cancel">
        </sc-button>
        <sc-content-spacer></sc-content-spacer>
        <sc-button primary [disabled]="!confirmEnabled" (click)="confirmDialog()" dictionaryKey="tmc-yard.ui.movement-orders.moving-order-rerouting-dialog.action.accept-movement-order">
        </sc-button>
      </sc-flex>
    </sc-padding>
  </sc-flex>
}
